<section class="success">
    <div class="container">
            <div class="row">
                <div class="success-message">
                    <div class="status d-flex justify-content-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="150" height="150" class="" fill="none" viewBox="0 0 24 24" stroke="#25d366" stroke-width="1">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </div>
                  <h2 class="text-center">{{ "successThanks" | translate }}</h2>
                  <h3 class="text-center">{{ "successReceived" | translate }}</h3>
                  <!-- <p class="text-center">{{ "successId" | translate }}</p> -->
                  <div class="go-to-orders d-flex justify-content-center pt-5" (click)="goToOrders()">
                    <div class="btn btn-primary">{{ "successReturn" | translate }}</div>
                  </div>
                </div>
            </div>
    </div>
</section>